//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as http from "@angular/common/http";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const VID_API_BASE_URL = new InjectionToken<string>('VID_API_BASE_URL');

@Injectable()
export class AccessTokenServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(VID_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateAccessTokenInput | undefined): Observable<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/services/vat/AccessToken/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessTokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessTokenDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AccessTokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateAccessTokenInput | undefined): Observable<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/services/vat/AccessToken/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessTokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessTokenDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AccessTokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    revoke(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/AccessToken/Revoke?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevoke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRevoke(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/AccessToken/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    list(body: ListInputOfAccessTokenFiltersDto | undefined): Observable<PagedResultDtoOfAccessTokenDto> {
        let url_ = this.baseUrl + "/api/services/vat/AccessToken/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAccessTokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAccessTokenDto>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<PagedResultDtoOfAccessTokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAccessTokenDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/services/vat/AccessToken/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessTokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessTokenDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AccessTokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AccessTokensCustomGrantsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(VID_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param permission (optional) 
     * @return OK
     */
    getPossibleUsers(permission: string | null | undefined): Observable<AssignableUserDto[]> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/GetPossibleUsers?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPossibleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPossibleUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableUserDto[]>;
        }));
    }

    protected processGetPossibleUsers(response: HttpResponseBase): Observable<AssignableUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignableUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return OK
     */
    getPossibleUsersOrOrganizationUnits(permission: string | null | undefined): Observable<UserOrOrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/GetPossibleUsersOrOrganizationUnits?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPossibleUsersOrOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPossibleUsersOrOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOrOrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOrOrganizationUnitDto[]>;
        }));
    }

    protected processGetPossibleUsersOrOrganizationUnits(response: HttpResponseBase): Observable<UserOrOrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param usersAndOrganizationUnits (optional) 
     * @return OK
     */
    checkCurrentUserIsInList(usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/CheckCurrentUserIsInList?";
        if (usersAndOrganizationUnits !== undefined && usersAndOrganizationUnits !== null)
            usersAndOrganizationUnits && usersAndOrganizationUnits.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "usersAndOrganizationUnits[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCurrentUserIsInList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentUserIsInList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCurrentUserIsInList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getExplicitUsersAndOrganizationUnitsHavingAccess(entityId: number | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/GetExplicitUsersAndOrganizationUnitsHavingAccess?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExplicitUsersAndOrganizationUnitsHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExplicitUsersAndOrganizationUnitsHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetExplicitUsersAndOrganizationUnitsHavingAccess(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkExplicitUsersAndOrganizationUnitsHavingAccess(body: CustomGrantsInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/CheckExplicitUsersAndOrganizationUnitsHavingAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExplicitUsersAndOrganizationUnitsHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExplicitUsersAndOrganizationUnitsHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExplicitUsersAndOrganizationUnitsHavingAccess(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setExplicitUsersAndOrganizationUnitsHavingAccess(body: CustomGrantsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/SetExplicitUsersAndOrganizationUnitsHavingAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetExplicitUsersAndOrganizationUnitsHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetExplicitUsersAndOrganizationUnitsHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetExplicitUsersAndOrganizationUnitsHavingAccess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAllUsersAndOrganizationUnitsEffectivelyHavingAccess(entityId: number | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/GetAllUsersAndOrganizationUnitsEffectivelyHavingAccess?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersAndOrganizationUnitsEffectivelyHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersAndOrganizationUnitsEffectivelyHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersAndOrganizationUnitsEffectivelyHavingAccess(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @return OK
     */
    checkHasAccess(entityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/CheckHasAccess?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHasAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHasAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckHasAccess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param permissionName (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getExplicitUsersAndOrganizationUnitsForPermission(entityId: number | undefined, permissionName: string | null | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/GetExplicitUsersAndOrganizationUnitsForPermission?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (permissionName !== undefined && permissionName !== null)
            url_ += "PermissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExplicitUsersAndOrganizationUnitsForPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExplicitUsersAndOrganizationUnitsForPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetExplicitUsersAndOrganizationUnitsForPermission(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setExplicitUsersAndOrganizationUnitsForPermission(body: CustomGrantsForPermissionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/SetExplicitUsersAndOrganizationUnitsForPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetExplicitUsersAndOrganizationUnitsForPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetExplicitUsersAndOrganizationUnitsForPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetExplicitUsersAndOrganizationUnitsForPermission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param permissionName (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAllUsersEffectivelyHavingPermission(entityId: number | undefined, permissionName: string | null | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/GetAllUsersEffectivelyHavingPermission?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (permissionName !== undefined && permissionName !== null)
            url_ += "PermissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersEffectivelyHavingPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersEffectivelyHavingPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersEffectivelyHavingPermission(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkHasPermission(entityId: number | undefined, body: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/CheckHasPermission?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHasPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHasPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckHasPermission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param provisionalData (optional) 
     * @param expandOrganizationUnits (optional) 
     * @return OK
     */
    getAllUsersAndOrganizationUnitsFromProvisionalData(provisionalData: UserOrOrganizationUnitInput[] | null | undefined, expandOrganizationUnits: boolean | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/GetAllUsersAndOrganizationUnitsFromProvisionalData?";
        if (provisionalData !== undefined && provisionalData !== null)
            provisionalData && provisionalData.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "provisionalData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (expandOrganizationUnits === null)
            throw new Error("The parameter 'expandOrganizationUnits' cannot be null.");
        else if (expandOrganizationUnits !== undefined)
            url_ += "expandOrganizationUnits=" + encodeURIComponent("" + expandOrganizationUnits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersAndOrganizationUnitsFromProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersAndOrganizationUnitsFromProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersAndOrganizationUnitsFromProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param provisionalData (optional) 
     * @return OK
     */
    getAllUsersFromProvisionalData(provisionalData: UserOrOrganizationUnitInput[] | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/GetAllUsersFromProvisionalData?";
        if (provisionalData !== undefined && provisionalData !== null)
            provisionalData && provisionalData.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "provisionalData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersFromProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersFromProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersFromProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param accessRestrictionProvisionalData (optional) 
     * @param permissionName (optional) 
     * @param excludeUsers (optional) 
     * @param entityId (optional) 
     * @param usersAndOrganizationUnits (optional) 
     * @return OK
     */
    getAllUsersEffectivelyHavingPermissionWithProvisionalData(accessRestrictionProvisionalData: UserOrOrganizationUnitInput[] | null | undefined, permissionName: string | null | undefined, excludeUsers: boolean | undefined, entityId: number | undefined, usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/GetAllUsersEffectivelyHavingPermissionWithProvisionalData?";
        if (accessRestrictionProvisionalData !== undefined && accessRestrictionProvisionalData !== null)
            accessRestrictionProvisionalData && accessRestrictionProvisionalData.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "AccessRestrictionProvisionalData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (permissionName !== undefined && permissionName !== null)
            url_ += "PermissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (excludeUsers === null)
            throw new Error("The parameter 'excludeUsers' cannot be null.");
        else if (excludeUsers !== undefined)
            url_ += "ExcludeUsers=" + encodeURIComponent("" + excludeUsers) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (usersAndOrganizationUnits !== undefined && usersAndOrganizationUnits !== null)
            usersAndOrganizationUnits && usersAndOrganizationUnits.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "UsersAndOrganizationUnits[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersEffectivelyHavingPermissionWithProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersEffectivelyHavingPermissionWithProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersEffectivelyHavingPermissionWithProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    queryFilterEntities(): Observable<ValueTupleOfIEnumerableOfInt64Boolean> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/QueryFilterEntities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryFilterEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryFilterEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfIEnumerableOfInt64Boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfIEnumerableOfInt64Boolean>;
        }));
    }

    protected processQueryFilterEntities(response: HttpResponseBase): Observable<ValueTupleOfIEnumerableOfInt64Boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfIEnumerableOfInt64Boolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkAccessRestrictions(body: CustomGrantsInput[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/CheckAccessRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAccessRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAccessRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckAccessRestrictions(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeAccessRestrictions(body: CustomGrantsInput[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/AccessTokensCustomGrants/ChangeAccessRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeAccessRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAccessRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeAccessRestrictions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExcelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(VID_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param prefillTokenId (optional) 
     * @return OK
     */
    get(prefillTokenId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/vat/Excel/Get?";
        if (prefillTokenId === null)
            throw new Error("The parameter 'prefillTokenId' cannot be null.");
        else if (prefillTokenId !== undefined)
            url_ += "prefillTokenId=" + encodeURIComponent("" + prefillTokenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    validate(requesterVat: string | null, vat: string | null, serviceProvider: string | null, companyName: string | null, streetAndNumber: string | null, zip: string | null, city: string | null, companyType: string | null): Observable<ExcelOutputDto> {
        let url_ = this.baseUrl + "/api/services/vat/Excel/Validate?";
        if (requesterVat === undefined)
            throw new Error("The parameter 'requesterVat' must be defined.");
        else if(requesterVat !== null)
            url_ += "RequesterVat=" + encodeURIComponent("" + requesterVat) + "&";
        if (vat === undefined)
            throw new Error("The parameter 'vat' must be defined.");
        else if(vat !== null)
            url_ += "Vat=" + encodeURIComponent("" + vat) + "&";
        if (serviceProvider === undefined)
            throw new Error("The parameter 'serviceProvider' must be defined.");
        else if(serviceProvider !== null)
            url_ += "ServiceProvider=" + encodeURIComponent("" + serviceProvider) + "&";
        if (companyName === undefined)
            throw new Error("The parameter 'companyName' must be defined.");
        else if(companyName !== null)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&";
        if (streetAndNumber === undefined)
            throw new Error("The parameter 'streetAndNumber' must be defined.");
        else if(streetAndNumber !== null)
            url_ += "StreetAndNumber=" + encodeURIComponent("" + streetAndNumber) + "&";
        if (zip === undefined)
            throw new Error("The parameter 'zip' must be defined.");
        else if(zip !== null)
            url_ += "Zip=" + encodeURIComponent("" + zip) + "&";
        if (city === undefined)
            throw new Error("The parameter 'city' must be defined.");
        else if(city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (companyType === undefined)
            throw new Error("The parameter 'companyType' must be defined.");
        else if(companyType !== null)
            url_ += "CompanyType=" + encodeURIComponent("" + companyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcelOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcelOutputDto>;
        }));
    }

    protected processValidate(response: HttpResponseBase): Observable<ExcelOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(VID_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    validate(id: number | undefined): Observable<RecordDto> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/Validate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordDto>;
        }));
    }

    protected processValidate(response: HttpResponseBase): Observable<RecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    bulkValidate(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/BulkValidate?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkValidate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateJobInput | undefined): Observable<CreateJobDto> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateJobDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateJobInput | undefined): Observable<CreateJobDto> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateJobDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CreateJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    bulkDelete(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/BulkDelete?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<JobDto> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<JobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    list(body: ListInputOfJobsFiltersDto | undefined): Observable<PagedResultDtoOfJobDto> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfJobDto>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<PagedResultDtoOfJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    import(body: ImportJobsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    importTemplate(): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/ImportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processImportTemplate(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    export(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/Export?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    exportProtocol(ids: number[] | null | undefined, from: DateTime | undefined, to: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/Jobs/ExportProtocol?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProtocol(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProtocol(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportProtocol(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobsCustomGrantsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(VID_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param permission (optional) 
     * @return OK
     */
    getPossibleUsers(permission: string | null | undefined): Observable<AssignableUserDto[]> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/GetPossibleUsers?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPossibleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPossibleUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableUserDto[]>;
        }));
    }

    protected processGetPossibleUsers(response: HttpResponseBase): Observable<AssignableUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignableUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return OK
     */
    getPossibleUsersOrOrganizationUnits(permission: string | null | undefined): Observable<UserOrOrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/GetPossibleUsersOrOrganizationUnits?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPossibleUsersOrOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPossibleUsersOrOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOrOrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOrOrganizationUnitDto[]>;
        }));
    }

    protected processGetPossibleUsersOrOrganizationUnits(response: HttpResponseBase): Observable<UserOrOrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param usersAndOrganizationUnits (optional) 
     * @return OK
     */
    checkCurrentUserIsInList(usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/CheckCurrentUserIsInList?";
        if (usersAndOrganizationUnits !== undefined && usersAndOrganizationUnits !== null)
            usersAndOrganizationUnits && usersAndOrganizationUnits.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "usersAndOrganizationUnits[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCurrentUserIsInList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentUserIsInList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCurrentUserIsInList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getExplicitUsersAndOrganizationUnitsHavingAccess(entityId: number | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/GetExplicitUsersAndOrganizationUnitsHavingAccess?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExplicitUsersAndOrganizationUnitsHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExplicitUsersAndOrganizationUnitsHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetExplicitUsersAndOrganizationUnitsHavingAccess(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkExplicitUsersAndOrganizationUnitsHavingAccess(body: CustomGrantsInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/CheckExplicitUsersAndOrganizationUnitsHavingAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExplicitUsersAndOrganizationUnitsHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExplicitUsersAndOrganizationUnitsHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExplicitUsersAndOrganizationUnitsHavingAccess(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setExplicitUsersAndOrganizationUnitsHavingAccess(body: CustomGrantsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/SetExplicitUsersAndOrganizationUnitsHavingAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetExplicitUsersAndOrganizationUnitsHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetExplicitUsersAndOrganizationUnitsHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetExplicitUsersAndOrganizationUnitsHavingAccess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAllUsersAndOrganizationUnitsEffectivelyHavingAccess(entityId: number | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/GetAllUsersAndOrganizationUnitsEffectivelyHavingAccess?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersAndOrganizationUnitsEffectivelyHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersAndOrganizationUnitsEffectivelyHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersAndOrganizationUnitsEffectivelyHavingAccess(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @return OK
     */
    checkHasAccess(entityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/CheckHasAccess?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHasAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHasAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckHasAccess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param permissionName (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getExplicitUsersAndOrganizationUnitsForPermission(entityId: number | undefined, permissionName: string | null | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/GetExplicitUsersAndOrganizationUnitsForPermission?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (permissionName !== undefined && permissionName !== null)
            url_ += "PermissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExplicitUsersAndOrganizationUnitsForPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExplicitUsersAndOrganizationUnitsForPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetExplicitUsersAndOrganizationUnitsForPermission(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setExplicitUsersAndOrganizationUnitsForPermission(body: CustomGrantsForPermissionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/SetExplicitUsersAndOrganizationUnitsForPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetExplicitUsersAndOrganizationUnitsForPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetExplicitUsersAndOrganizationUnitsForPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetExplicitUsersAndOrganizationUnitsForPermission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param permissionName (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAllUsersEffectivelyHavingPermission(entityId: number | undefined, permissionName: string | null | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/GetAllUsersEffectivelyHavingPermission?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (permissionName !== undefined && permissionName !== null)
            url_ += "PermissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersEffectivelyHavingPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersEffectivelyHavingPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersEffectivelyHavingPermission(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkHasPermission(entityId: number | undefined, body: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/CheckHasPermission?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHasPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHasPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckHasPermission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param provisionalData (optional) 
     * @param expandOrganizationUnits (optional) 
     * @return OK
     */
    getAllUsersAndOrganizationUnitsFromProvisionalData(provisionalData: UserOrOrganizationUnitInput[] | null | undefined, expandOrganizationUnits: boolean | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/GetAllUsersAndOrganizationUnitsFromProvisionalData?";
        if (provisionalData !== undefined && provisionalData !== null)
            provisionalData && provisionalData.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "provisionalData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (expandOrganizationUnits === null)
            throw new Error("The parameter 'expandOrganizationUnits' cannot be null.");
        else if (expandOrganizationUnits !== undefined)
            url_ += "expandOrganizationUnits=" + encodeURIComponent("" + expandOrganizationUnits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersAndOrganizationUnitsFromProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersAndOrganizationUnitsFromProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersAndOrganizationUnitsFromProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param provisionalData (optional) 
     * @return OK
     */
    getAllUsersFromProvisionalData(provisionalData: UserOrOrganizationUnitInput[] | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/GetAllUsersFromProvisionalData?";
        if (provisionalData !== undefined && provisionalData !== null)
            provisionalData && provisionalData.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "provisionalData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersFromProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersFromProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersFromProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param accessRestrictionProvisionalData (optional) 
     * @param permissionName (optional) 
     * @param excludeUsers (optional) 
     * @param entityId (optional) 
     * @param usersAndOrganizationUnits (optional) 
     * @return OK
     */
    getAllUsersEffectivelyHavingPermissionWithProvisionalData(accessRestrictionProvisionalData: UserOrOrganizationUnitInput[] | null | undefined, permissionName: string | null | undefined, excludeUsers: boolean | undefined, entityId: number | undefined, usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/GetAllUsersEffectivelyHavingPermissionWithProvisionalData?";
        if (accessRestrictionProvisionalData !== undefined && accessRestrictionProvisionalData !== null)
            accessRestrictionProvisionalData && accessRestrictionProvisionalData.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "AccessRestrictionProvisionalData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (permissionName !== undefined && permissionName !== null)
            url_ += "PermissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (excludeUsers === null)
            throw new Error("The parameter 'excludeUsers' cannot be null.");
        else if (excludeUsers !== undefined)
            url_ += "ExcludeUsers=" + encodeURIComponent("" + excludeUsers) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (usersAndOrganizationUnits !== undefined && usersAndOrganizationUnits !== null)
            usersAndOrganizationUnits && usersAndOrganizationUnits.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "UsersAndOrganizationUnits[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersEffectivelyHavingPermissionWithProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersEffectivelyHavingPermissionWithProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersEffectivelyHavingPermissionWithProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    queryFilterEntities(): Observable<ValueTupleOfIEnumerableOfInt64Boolean> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/QueryFilterEntities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryFilterEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryFilterEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfIEnumerableOfInt64Boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfIEnumerableOfInt64Boolean>;
        }));
    }

    protected processQueryFilterEntities(response: HttpResponseBase): Observable<ValueTupleOfIEnumerableOfInt64Boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfIEnumerableOfInt64Boolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkAccessRestrictions(body: CustomGrantsInput[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/CheckAccessRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAccessRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAccessRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckAccessRestrictions(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeAccessRestrictions(body: CustomGrantsInput[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/JobsCustomGrants/ChangeAccessRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeAccessRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAccessRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeAccessRestrictions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProtocolServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(VID_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    list(body: ListInputOfProtocolFiltersDto | undefined): Observable<PagedResultDtoOfRecordDto> {
        let url_ = this.baseUrl + "/api/services/vat/Protocol/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRecordDto>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<PagedResultDtoOfRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    listGroups(body: ListInputOfProtocolFiltersDto | undefined): Observable<PagedResultDtoOfRecordGroupDto> {
        let url_ = this.baseUrl + "/api/services/vat/Protocol/ListGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRecordGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRecordGroupDto>;
        }));
    }

    protected processListGroups(response: HttpResponseBase): Observable<PagedResultDtoOfRecordGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRecordGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestedVatId (optional) 
     * @param requesterVatId (optional) 
     * @param body (optional) 
     * @return OK
     */
    listInGroup(requestedVatId: string | null | undefined, requesterVatId: string | null | undefined, body: ListInputOfProtocolFiltersDto | undefined): Observable<PagedResultDtoOfRecordDto> {
        let url_ = this.baseUrl + "/api/services/vat/Protocol/ListInGroup?";
        if (requestedVatId !== undefined && requestedVatId !== null)
            url_ += "requestedVatId=" + encodeURIComponent("" + requestedVatId) + "&";
        if (requesterVatId !== undefined && requesterVatId !== null)
            url_ += "requesterVatId=" + encodeURIComponent("" + requesterVatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListInGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListInGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRecordDto>;
        }));
    }

    protected processListInGroup(response: HttpResponseBase): Observable<PagedResultDtoOfRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/Protocol/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    bulkDelete(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/Protocol/BulkDelete?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    export(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/Protocol/Export?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    get(ids: number[] | null | undefined): Observable<RecordDto[]> {
        let url_ = this.baseUrl + "/api/services/vat/Protocol/Get?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProtocolCustomGrantsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(VID_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param permission (optional) 
     * @return OK
     */
    getPossibleUsers(permission: string | null | undefined): Observable<AssignableUserDto[]> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/GetPossibleUsers?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPossibleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPossibleUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableUserDto[]>;
        }));
    }

    protected processGetPossibleUsers(response: HttpResponseBase): Observable<AssignableUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignableUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return OK
     */
    getPossibleUsersOrOrganizationUnits(permission: string | null | undefined): Observable<UserOrOrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/GetPossibleUsersOrOrganizationUnits?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPossibleUsersOrOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPossibleUsersOrOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOrOrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOrOrganizationUnitDto[]>;
        }));
    }

    protected processGetPossibleUsersOrOrganizationUnits(response: HttpResponseBase): Observable<UserOrOrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param usersAndOrganizationUnits (optional) 
     * @return OK
     */
    checkCurrentUserIsInList(usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/CheckCurrentUserIsInList?";
        if (usersAndOrganizationUnits !== undefined && usersAndOrganizationUnits !== null)
            usersAndOrganizationUnits && usersAndOrganizationUnits.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "usersAndOrganizationUnits[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCurrentUserIsInList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentUserIsInList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCurrentUserIsInList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getExplicitUsersAndOrganizationUnitsHavingAccess(entityId: number | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/GetExplicitUsersAndOrganizationUnitsHavingAccess?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExplicitUsersAndOrganizationUnitsHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExplicitUsersAndOrganizationUnitsHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetExplicitUsersAndOrganizationUnitsHavingAccess(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkExplicitUsersAndOrganizationUnitsHavingAccess(body: CustomGrantsInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/CheckExplicitUsersAndOrganizationUnitsHavingAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExplicitUsersAndOrganizationUnitsHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExplicitUsersAndOrganizationUnitsHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExplicitUsersAndOrganizationUnitsHavingAccess(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setExplicitUsersAndOrganizationUnitsHavingAccess(body: CustomGrantsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/SetExplicitUsersAndOrganizationUnitsHavingAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetExplicitUsersAndOrganizationUnitsHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetExplicitUsersAndOrganizationUnitsHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetExplicitUsersAndOrganizationUnitsHavingAccess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAllUsersAndOrganizationUnitsEffectivelyHavingAccess(entityId: number | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/GetAllUsersAndOrganizationUnitsEffectivelyHavingAccess?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersAndOrganizationUnitsEffectivelyHavingAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersAndOrganizationUnitsEffectivelyHavingAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersAndOrganizationUnitsEffectivelyHavingAccess(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @return OK
     */
    checkHasAccess(entityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/CheckHasAccess?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHasAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHasAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckHasAccess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param permissionName (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getExplicitUsersAndOrganizationUnitsForPermission(entityId: number | undefined, permissionName: string | null | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/GetExplicitUsersAndOrganizationUnitsForPermission?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (permissionName !== undefined && permissionName !== null)
            url_ += "PermissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExplicitUsersAndOrganizationUnitsForPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExplicitUsersAndOrganizationUnitsForPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetExplicitUsersAndOrganizationUnitsForPermission(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setExplicitUsersAndOrganizationUnitsForPermission(body: CustomGrantsForPermissionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/SetExplicitUsersAndOrganizationUnitsForPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetExplicitUsersAndOrganizationUnitsForPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetExplicitUsersAndOrganizationUnitsForPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetExplicitUsersAndOrganizationUnitsForPermission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param permissionName (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAllUsersEffectivelyHavingPermission(entityId: number | undefined, permissionName: string | null | undefined, filter: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/GetAllUsersEffectivelyHavingPermission?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (permissionName !== undefined && permissionName !== null)
            url_ += "PermissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersEffectivelyHavingPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersEffectivelyHavingPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersEffectivelyHavingPermission(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkHasPermission(entityId: number | undefined, body: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/CheckHasPermission?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHasPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHasPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckHasPermission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param provisionalData (optional) 
     * @param expandOrganizationUnits (optional) 
     * @return OK
     */
    getAllUsersAndOrganizationUnitsFromProvisionalData(provisionalData: UserOrOrganizationUnitInput[] | null | undefined, expandOrganizationUnits: boolean | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/GetAllUsersAndOrganizationUnitsFromProvisionalData?";
        if (provisionalData !== undefined && provisionalData !== null)
            provisionalData && provisionalData.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "provisionalData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (expandOrganizationUnits === null)
            throw new Error("The parameter 'expandOrganizationUnits' cannot be null.");
        else if (expandOrganizationUnits !== undefined)
            url_ += "expandOrganizationUnits=" + encodeURIComponent("" + expandOrganizationUnits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersAndOrganizationUnitsFromProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersAndOrganizationUnitsFromProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersAndOrganizationUnitsFromProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param provisionalData (optional) 
     * @return OK
     */
    getAllUsersFromProvisionalData(provisionalData: UserOrOrganizationUnitInput[] | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/GetAllUsersFromProvisionalData?";
        if (provisionalData !== undefined && provisionalData !== null)
            provisionalData && provisionalData.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "provisionalData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersFromProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersFromProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersFromProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param accessRestrictionProvisionalData (optional) 
     * @param permissionName (optional) 
     * @param excludeUsers (optional) 
     * @param entityId (optional) 
     * @param usersAndOrganizationUnits (optional) 
     * @return OK
     */
    getAllUsersEffectivelyHavingPermissionWithProvisionalData(accessRestrictionProvisionalData: UserOrOrganizationUnitInput[] | null | undefined, permissionName: string | null | undefined, excludeUsers: boolean | undefined, entityId: number | undefined, usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/GetAllUsersEffectivelyHavingPermissionWithProvisionalData?";
        if (accessRestrictionProvisionalData !== undefined && accessRestrictionProvisionalData !== null)
            accessRestrictionProvisionalData && accessRestrictionProvisionalData.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "AccessRestrictionProvisionalData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (permissionName !== undefined && permissionName !== null)
            url_ += "PermissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (excludeUsers === null)
            throw new Error("The parameter 'excludeUsers' cannot be null.");
        else if (excludeUsers !== undefined)
            url_ += "ExcludeUsers=" + encodeURIComponent("" + excludeUsers) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (usersAndOrganizationUnits !== undefined && usersAndOrganizationUnits !== null)
            usersAndOrganizationUnits && usersAndOrganizationUnits.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "UsersAndOrganizationUnits[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersEffectivelyHavingPermissionWithProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersEffectivelyHavingPermissionWithProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllUsersEffectivelyHavingPermissionWithProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    queryFilterEntities(): Observable<ValueTupleOfIEnumerableOfInt64Boolean> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/QueryFilterEntities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryFilterEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryFilterEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfIEnumerableOfInt64Boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfIEnumerableOfInt64Boolean>;
        }));
    }

    protected processQueryFilterEntities(response: HttpResponseBase): Observable<ValueTupleOfIEnumerableOfInt64Boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfIEnumerableOfInt64Boolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkAccessRestrictions(body: CustomGrantsInput[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/CheckAccessRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAccessRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAccessRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckAccessRestrictions(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeAccessRestrictions(body: CustomGrantsInput[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/ProtocolCustomGrants/ChangeAccessRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeAccessRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAccessRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeAccessRestrictions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ValidationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(VID_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validate(body: ValidationInput | undefined): Observable<RecordDto> {
        let url_ = this.baseUrl + "/api/services/vat/Validation/Validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordDto>;
        }));
    }

    protected processValidate(response: HttpResponseBase): Observable<RecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkValidate(body: ValidationInput[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/Validation/BulkValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkValidate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VatUserGridConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(VID_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setColumnVisibilitySettings(body: MazarsGridDefinitionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/vat/VatUserGridConfiguration/SetColumnVisibilitySettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetColumnVisibilitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetColumnVisibilitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetColumnVisibilitySettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @return OK
     */
    getGridColumnSettings(key: string | null | undefined): Observable<MazarsGridDefinitionDto> {
        let url_ = this.baseUrl + "/api/services/vat/VatUserGridConfiguration/GetGridColumnSettings?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGridColumnSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGridColumnSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MazarsGridDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MazarsGridDefinitionDto>;
        }));
    }

    protected processGetGridColumnSettings(response: HttpResponseBase): Observable<MazarsGridDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MazarsGridDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @return OK
     */
    resetGridColumnSettings(key: string | null | undefined): Observable<MazarsGridDefinitionDto> {
        let url_ = this.baseUrl + "/api/services/vat/VatUserGridConfiguration/ResetGridColumnSettings?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetGridColumnSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetGridColumnSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MazarsGridDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MazarsGridDefinitionDto>;
        }));
    }

    protected processResetGridColumnSettings(response: HttpResponseBase): Observable<MazarsGridDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MazarsGridDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VatUserManualsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(VID_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param languageCode (optional) 
     * @return OK
     */
    getUserManual(languageCode: string | null | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/vat/VatUserManuals/GetUserManual?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserManual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserManual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processGetUserManual(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AccessTokenDto implements IAccessTokenDto {
    id!: number;
    name!: string | undefined;
    customGrants!: UserOrOrganizationUnitDto[] | undefined;
    expirationDate!: DateTime | undefined;
    isRevoked!: boolean;
    note!: string | undefined;
    encodedSecret!: string | undefined;

    constructor(data?: IAccessTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["customGrants"])) {
                this.customGrants = [] as any;
                for (let item of _data["customGrants"])
                    this.customGrants!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : <any>undefined;
            this.isRevoked = _data["isRevoked"];
            this.note = _data["note"];
            this.encodedSecret = _data["encodedSecret"];
        }
    }

    static fromJS(data: any): AccessTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.customGrants)) {
            data["customGrants"] = [];
            for (let item of this.customGrants)
                data["customGrants"].push(item.toJSON());
        }
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : <any>undefined;
        data["isRevoked"] = this.isRevoked;
        data["note"] = this.note;
        data["encodedSecret"] = this.encodedSecret;
        return data;
    }
}

export interface IAccessTokenDto {
    id: number;
    name: string | undefined;
    customGrants: UserOrOrganizationUnitDto[] | undefined;
    expirationDate: DateTime | undefined;
    isRevoked: boolean;
    note: string | undefined;
    encodedSecret: string | undefined;
}

export class AccessTokenFiltersDto implements IAccessTokenFiltersDto {
    searchString!: string | undefined;
    status!: AccessTokenStatusDto[] | undefined;
    expirationDate!: FilterInterval | undefined;

    constructor(data?: IAccessTokenFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.expirationDate = _data["expirationDate"] ? FilterInterval.fromJS(_data["expirationDate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccessTokenFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchString"] = this.searchString;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccessTokenFiltersDto {
    searchString: string | undefined;
    status: AccessTokenStatusDto[] | undefined;
    expirationDate: FilterInterval | undefined;
}

export enum AccessTokenStatusDto {
    Valid = 0,
    Revoked = 1,
    Expired = 2,
}

export class AssignableUserDto implements IAssignableUserDto {
    id!: number;
    fullName!: string | undefined;
    userName!: string | undefined;

    constructor(data?: IAssignableUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AssignableUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAssignableUserDto {
    id: number;
    fullName: string | undefined;
    userName: string | undefined;
}

export class CreateAccessTokenInput implements ICreateAccessTokenInput {
    name!: string | undefined;
    customGrants!: UserOrOrganizationUnitInput[] | undefined;
    expirationDate!: DateTime | undefined;
    note!: string | undefined;

    constructor(data?: ICreateAccessTokenInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["customGrants"])) {
                this.customGrants = [] as any;
                for (let item of _data["customGrants"])
                    this.customGrants!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateAccessTokenInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccessTokenInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customGrants)) {
            data["customGrants"] = [];
            for (let item of this.customGrants)
                data["customGrants"].push(item.toJSON());
        }
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }
}

export interface ICreateAccessTokenInput {
    name: string | undefined;
    customGrants: UserOrOrganizationUnitInput[] | undefined;
    expirationDate: DateTime | undefined;
    note: string | undefined;
}

export class CreateJobDto implements ICreateJobDto {
    job!: JobDto | undefined;
    initialRecord!: RecordDto | undefined;
    initialError!: string | undefined;

    constructor(data?: ICreateJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.job = _data["job"] ? JobDto.fromJS(_data["job"]) : <any>undefined;
            this.initialRecord = _data["initialRecord"] ? RecordDto.fromJS(_data["initialRecord"]) : <any>undefined;
            this.initialError = _data["initialError"];
        }
    }

    static fromJS(data: any): CreateJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        data["initialRecord"] = this.initialRecord ? this.initialRecord.toJSON() : <any>undefined;
        data["initialError"] = this.initialError;
        return data;
    }
}

export interface ICreateJobDto {
    job: JobDto | undefined;
    initialRecord: RecordDto | undefined;
    initialError: string | undefined;
}

export class CreateJobInput implements ICreateJobInput {
    name!: string | undefined;
    reoccurrence!: ReoccurrenceDto | undefined;
    data!: ValidationDataInput | undefined;
    assignedUserId!: number | undefined;
    notifier!: JobNotifierDto;
    retry!: boolean;
    customGrants!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: ICreateJobInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.reoccurrence = _data["reoccurrence"] ? ReoccurrenceDto.fromJS(_data["reoccurrence"]) : <any>undefined;
            this.data = _data["data"] ? ValidationDataInput.fromJS(_data["data"]) : <any>undefined;
            this.assignedUserId = _data["assignedUserId"];
            this.notifier = _data["notifier"];
            this.retry = _data["retry"];
            if (Array.isArray(_data["customGrants"])) {
                this.customGrants = [] as any;
                for (let item of _data["customGrants"])
                    this.customGrants!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateJobInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reoccurrence"] = this.reoccurrence ? this.reoccurrence.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["assignedUserId"] = this.assignedUserId;
        data["notifier"] = this.notifier;
        data["retry"] = this.retry;
        if (Array.isArray(this.customGrants)) {
            data["customGrants"] = [];
            for (let item of this.customGrants)
                data["customGrants"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateJobInput {
    name: string | undefined;
    reoccurrence: ReoccurrenceDto | undefined;
    data: ValidationDataInput | undefined;
    assignedUserId: number | undefined;
    notifier: JobNotifierDto;
    retry: boolean;
    customGrants: UserOrOrganizationUnitInput[] | undefined;
}

export class CustomGrantsForPermissionInput implements ICustomGrantsForPermissionInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    permissionName!: string | undefined;
    excludeUsers!: boolean;

    constructor(data?: ICustomGrantsForPermissionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.permissionName = _data["permissionName"];
            this.excludeUsers = _data["excludeUsers"];
        }
    }

    static fromJS(data: any): CustomGrantsForPermissionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsForPermissionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        data["permissionName"] = this.permissionName;
        data["excludeUsers"] = this.excludeUsers;
        return data;
    }
}

export interface ICustomGrantsForPermissionInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    permissionName: string | undefined;
    excludeUsers: boolean;
}

export class CustomGrantsInput implements ICustomGrantsInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: ICustomGrantsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomGrantsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomGrantsInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
}

export class DailyReoccurrenceDto implements IDailyReoccurrenceDto {
    startingFrom!: DateTime;
    interval!: number;

    constructor(data?: IDailyReoccurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startingFrom = _data["startingFrom"] ? DateTime.fromISO(_data["startingFrom"].toString()) : <any>undefined;
            this.interval = _data["interval"];
        }
    }

    static fromJS(data: any): DailyReoccurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyReoccurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startingFrom"] = this.startingFrom ? this.startingFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["interval"] = this.interval;
        return data;
    }
}

export interface IDailyReoccurrenceDto {
    startingFrom: DateTime;
    interval: number;
}

export class DisclosureValidationResultDto implements IDisclosureValidationResultDto {
    companyName!: string | undefined;
    companyAddress!: string | undefined;
    validCompanyName!: boolean | undefined;
    validCompanyAddress!: boolean | undefined;
    expectedCompanyAddress!: string | undefined;
    expectedCompanyName!: string | undefined;
    manuallyValidated!: boolean;

    constructor(data?: IDisclosureValidationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.companyAddress = _data["companyAddress"];
            this.validCompanyName = _data["validCompanyName"];
            this.validCompanyAddress = _data["validCompanyAddress"];
            this.expectedCompanyAddress = _data["expectedCompanyAddress"];
            this.expectedCompanyName = _data["expectedCompanyName"];
            this.manuallyValidated = _data["manuallyValidated"];
        }
    }

    static fromJS(data: any): DisclosureValidationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisclosureValidationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["companyAddress"] = this.companyAddress;
        data["validCompanyName"] = this.validCompanyName;
        data["validCompanyAddress"] = this.validCompanyAddress;
        data["expectedCompanyAddress"] = this.expectedCompanyAddress;
        data["expectedCompanyName"] = this.expectedCompanyName;
        data["manuallyValidated"] = this.manuallyValidated;
        return data;
    }
}

export interface IDisclosureValidationResultDto {
    companyName: string | undefined;
    companyAddress: string | undefined;
    validCompanyName: boolean | undefined;
    validCompanyAddress: boolean | undefined;
    expectedCompanyAddress: string | undefined;
    expectedCompanyName: string | undefined;
    manuallyValidated: boolean;
}

export class ExcelOutputDto implements IExcelOutputDto {
    date!: DateTime;
    isVatValid!: boolean;
    isCompanyNameMatch!: boolean | undefined;
    isStreetMatch!: boolean | undefined;
    isZipMatch!: boolean | undefined;
    isCityMatch!: boolean | undefined;
    isCompanyTypeMatch!: boolean | undefined;
    validationId!: number;
    expectedName!: string | undefined;
    expectedAddress!: string | undefined;
    rawResponse!: string | undefined;

    constructor(data?: IExcelOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.isVatValid = _data["isVatValid"];
            this.isCompanyNameMatch = _data["isCompanyNameMatch"];
            this.isStreetMatch = _data["isStreetMatch"];
            this.isZipMatch = _data["isZipMatch"];
            this.isCityMatch = _data["isCityMatch"];
            this.isCompanyTypeMatch = _data["isCompanyTypeMatch"];
            this.validationId = _data["validationId"];
            this.expectedName = _data["expectedName"];
            this.expectedAddress = _data["expectedAddress"];
            this.rawResponse = _data["rawResponse"];
        }
    }

    static fromJS(data: any): ExcelOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["isVatValid"] = this.isVatValid;
        data["isCompanyNameMatch"] = this.isCompanyNameMatch;
        data["isStreetMatch"] = this.isStreetMatch;
        data["isZipMatch"] = this.isZipMatch;
        data["isCityMatch"] = this.isCityMatch;
        data["isCompanyTypeMatch"] = this.isCompanyTypeMatch;
        data["validationId"] = this.validationId;
        data["expectedName"] = this.expectedName;
        data["expectedAddress"] = this.expectedAddress;
        data["rawResponse"] = this.rawResponse;
        return data;
    }
}

export interface IExcelOutputDto {
    date: DateTime;
    isVatValid: boolean;
    isCompanyNameMatch: boolean | undefined;
    isStreetMatch: boolean | undefined;
    isZipMatch: boolean | undefined;
    isCityMatch: boolean | undefined;
    isCompanyTypeMatch: boolean | undefined;
    validationId: number;
    expectedName: string | undefined;
    expectedAddress: string | undefined;
    rawResponse: string | undefined;
}

export class FileDownloadDto implements IFileDownloadDto {
    fileName!: string | undefined;
    readonly content!: string | undefined;
    readonly mimeType!: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            (<any>this).content = _data["content"];
            (<any>this).mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface IFileDownloadDto {
    fileName: string | undefined;
    content: string | undefined;
    mimeType: string | undefined;
}

export class FilterInterval implements IFilterInterval {
    from!: DateTime;
    to!: DateTime;

    constructor(data?: IFilterInterval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? DateTime.fromISO(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? DateTime.fromISO(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FilterInterval {
        data = typeof data === 'object' ? data : {};
        let result = new FilterInterval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toString() : <any>undefined;
        data["to"] = this.to ? this.to.toString() : <any>undefined;
        return data;
    }
}

export interface IFilterInterval {
    from: DateTime;
    to: DateTime;
}

export class ImportJobsInput implements IImportJobsInput {
    fileToken!: string | undefined;
    namePrefix!: string | undefined;
    reoccurrence!: ReoccurrenceDto | undefined;
    assignedUserId!: number | undefined;
    notifier!: JobNotifierDto;
    retry!: boolean;
    customGrants!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: IImportJobsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.namePrefix = _data["namePrefix"];
            this.reoccurrence = _data["reoccurrence"] ? ReoccurrenceDto.fromJS(_data["reoccurrence"]) : <any>undefined;
            this.assignedUserId = _data["assignedUserId"];
            this.notifier = _data["notifier"];
            this.retry = _data["retry"];
            if (Array.isArray(_data["customGrants"])) {
                this.customGrants = [] as any;
                for (let item of _data["customGrants"])
                    this.customGrants!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportJobsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["namePrefix"] = this.namePrefix;
        data["reoccurrence"] = this.reoccurrence ? this.reoccurrence.toJSON() : <any>undefined;
        data["assignedUserId"] = this.assignedUserId;
        data["notifier"] = this.notifier;
        data["retry"] = this.retry;
        if (Array.isArray(this.customGrants)) {
            data["customGrants"] = [];
            for (let item of this.customGrants)
                data["customGrants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImportJobsInput {
    fileToken: string | undefined;
    namePrefix: string | undefined;
    reoccurrence: ReoccurrenceDto | undefined;
    assignedUserId: number | undefined;
    notifier: JobNotifierDto;
    retry: boolean;
    customGrants: UserOrOrganizationUnitInput[] | undefined;
}

export class JobDto implements IJobDto {
    id!: number;
    creationTime!: DateTime;
    creatorUser!: AssignableUserDto | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUser!: AssignableUserDto | undefined;
    assignedUser!: AssignableUserDto | undefined;
    notifier!: JobNotifierDto;
    retry!: boolean;
    name!: string | undefined;
    lastValidation!: RecordDto | undefined;
    reoccurrence!: ReoccurrenceDto | undefined;
    nextValidation!: DateTime | undefined;
    data!: ValidationDataDto | undefined;
    customGrants!: UserOrOrganizationUnitDto[] | undefined;

    constructor(data?: IJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? AssignableUserDto.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? AssignableUserDto.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.notifier = _data["notifier"];
            this.retry = _data["retry"];
            this.name = _data["name"];
            this.lastValidation = _data["lastValidation"] ? RecordDto.fromJS(_data["lastValidation"]) : <any>undefined;
            this.reoccurrence = _data["reoccurrence"] ? ReoccurrenceDto.fromJS(_data["reoccurrence"]) : <any>undefined;
            this.nextValidation = _data["nextValidation"] ? DateTime.fromISO(_data["nextValidation"].toString()) : <any>undefined;
            this.data = _data["data"] ? ValidationDataDto.fromJS(_data["data"]) : <any>undefined;
            if (Array.isArray(_data["customGrants"])) {
                this.customGrants = [] as any;
                for (let item of _data["customGrants"])
                    this.customGrants!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["notifier"] = this.notifier;
        data["retry"] = this.retry;
        data["name"] = this.name;
        data["lastValidation"] = this.lastValidation ? this.lastValidation.toJSON() : <any>undefined;
        data["reoccurrence"] = this.reoccurrence ? this.reoccurrence.toJSON() : <any>undefined;
        data["nextValidation"] = this.nextValidation ? this.nextValidation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (Array.isArray(this.customGrants)) {
            data["customGrants"] = [];
            for (let item of this.customGrants)
                data["customGrants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJobDto {
    id: number;
    creationTime: DateTime;
    creatorUser: AssignableUserDto | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUser: AssignableUserDto | undefined;
    assignedUser: AssignableUserDto | undefined;
    notifier: JobNotifierDto;
    retry: boolean;
    name: string | undefined;
    lastValidation: RecordDto | undefined;
    reoccurrence: ReoccurrenceDto | undefined;
    nextValidation: DateTime | undefined;
    data: ValidationDataDto | undefined;
    customGrants: UserOrOrganizationUnitDto[] | undefined;
}

export enum JobNotifierDto {
    AllWithAccess = 0,
    AssignedUser = 1,
    NoOne = 2,
}

export class JobsFiltersDto implements IJobsFiltersDto {
    searchString!: string | undefined;
    status!: ValidationStatusDto[] | undefined;
    lastValidation!: FilterInterval | undefined;
    type!: ValidationTypeDto[] | undefined;
    creationDate!: FilterInterval | undefined;
    lastModificationDate!: FilterInterval | undefined;
    organizationUnitId!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: IJobsFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.lastValidation = _data["lastValidation"] ? FilterInterval.fromJS(_data["lastValidation"]) : <any>undefined;
            if (Array.isArray(_data["type"])) {
                this.type = [] as any;
                for (let item of _data["type"])
                    this.type!.push(item);
            }
            this.creationDate = _data["creationDate"] ? FilterInterval.fromJS(_data["creationDate"]) : <any>undefined;
            this.lastModificationDate = _data["lastModificationDate"] ? FilterInterval.fromJS(_data["lastModificationDate"]) : <any>undefined;
            if (Array.isArray(_data["organizationUnitId"])) {
                this.organizationUnitId = [] as any;
                for (let item of _data["organizationUnitId"])
                    this.organizationUnitId!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobsFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobsFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchString"] = this.searchString;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["lastValidation"] = this.lastValidation ? this.lastValidation.toJSON() : <any>undefined;
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item of this.type)
                data["type"].push(item);
        }
        data["creationDate"] = this.creationDate ? this.creationDate.toJSON() : <any>undefined;
        data["lastModificationDate"] = this.lastModificationDate ? this.lastModificationDate.toJSON() : <any>undefined;
        if (Array.isArray(this.organizationUnitId)) {
            data["organizationUnitId"] = [];
            for (let item of this.organizationUnitId)
                data["organizationUnitId"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJobsFiltersDto {
    searchString: string | undefined;
    status: ValidationStatusDto[] | undefined;
    lastValidation: FilterInterval | undefined;
    type: ValidationTypeDto[] | undefined;
    creationDate: FilterInterval | undefined;
    lastModificationDate: FilterInterval | undefined;
    organizationUnitId: UserOrOrganizationUnitInput[] | undefined;
}

export class ListInputOfAccessTokenFiltersDto implements IListInputOfAccessTokenFiltersDto {
    maxResultCount!: number;
    skipCount!: number;
    filters!: AccessTokenFiltersDto | undefined;

    constructor(data?: IListInputOfAccessTokenFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filters = _data["filters"] ? AccessTokenFiltersDto.fromJS(_data["filters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListInputOfAccessTokenFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListInputOfAccessTokenFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filters"] = this.filters ? this.filters.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListInputOfAccessTokenFiltersDto {
    maxResultCount: number;
    skipCount: number;
    filters: AccessTokenFiltersDto | undefined;
}

export class ListInputOfJobsFiltersDto implements IListInputOfJobsFiltersDto {
    maxResultCount!: number;
    skipCount!: number;
    filters!: JobsFiltersDto | undefined;

    constructor(data?: IListInputOfJobsFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filters = _data["filters"] ? JobsFiltersDto.fromJS(_data["filters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListInputOfJobsFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListInputOfJobsFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filters"] = this.filters ? this.filters.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListInputOfJobsFiltersDto {
    maxResultCount: number;
    skipCount: number;
    filters: JobsFiltersDto | undefined;
}

export class ListInputOfProtocolFiltersDto implements IListInputOfProtocolFiltersDto {
    maxResultCount!: number;
    skipCount!: number;
    filters!: ProtocolFiltersDto | undefined;

    constructor(data?: IListInputOfProtocolFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filters = _data["filters"] ? ProtocolFiltersDto.fromJS(_data["filters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListInputOfProtocolFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListInputOfProtocolFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filters"] = this.filters ? this.filters.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListInputOfProtocolFiltersDto {
    maxResultCount: number;
    skipCount: number;
    filters: ProtocolFiltersDto | undefined;
}

export class ListResultDtoOfUserOrOrganizationUnitDto implements IListResultDtoOfUserOrOrganizationUnitDto {
    items!: UserOrOrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfUserOrOrganizationUnitDto {
    items: UserOrOrganizationUnitDto[] | undefined;
}

export class MatchedValidationResultDto implements IMatchedValidationResultDto {
    companyName!: string | undefined;
    companyStreet!: string | undefined;
    companyZip!: string | undefined;
    companyCounty!: string | undefined;
    validCompanyName!: boolean | undefined;
    validCompanyStreet!: boolean | undefined;
    validCompanyZip!: boolean | undefined;
    validCompanyCounty!: boolean | undefined;

    constructor(data?: IMatchedValidationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.companyStreet = _data["companyStreet"];
            this.companyZip = _data["companyZip"];
            this.companyCounty = _data["companyCounty"];
            this.validCompanyName = _data["validCompanyName"];
            this.validCompanyStreet = _data["validCompanyStreet"];
            this.validCompanyZip = _data["validCompanyZip"];
            this.validCompanyCounty = _data["validCompanyCounty"];
        }
    }

    static fromJS(data: any): MatchedValidationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchedValidationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["companyStreet"] = this.companyStreet;
        data["companyZip"] = this.companyZip;
        data["companyCounty"] = this.companyCounty;
        data["validCompanyName"] = this.validCompanyName;
        data["validCompanyStreet"] = this.validCompanyStreet;
        data["validCompanyZip"] = this.validCompanyZip;
        data["validCompanyCounty"] = this.validCompanyCounty;
        return data;
    }
}

export interface IMatchedValidationResultDto {
    companyName: string | undefined;
    companyStreet: string | undefined;
    companyZip: string | undefined;
    companyCounty: string | undefined;
    validCompanyName: boolean | undefined;
    validCompanyStreet: boolean | undefined;
    validCompanyZip: boolean | undefined;
    validCompanyCounty: boolean | undefined;
}

export class MazarsColumnDefinitionDto implements IMazarsColumnDefinitionDto {
    field!: string | undefined;
    isDefault!: boolean;
    visible!: boolean;
    localizationKey!: string | undefined;
    localizationSource!: string | undefined;
    localizedField!: string | undefined;
    width!: number;
    canBeChanged!: boolean;
    order!: number;
    sortableName!: string | undefined;

    constructor(data?: IMazarsColumnDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.isDefault = _data["isDefault"];
            this.visible = _data["visible"];
            this.localizationKey = _data["localizationKey"];
            this.localizationSource = _data["localizationSource"];
            this.localizedField = _data["localizedField"];
            this.width = _data["width"];
            this.canBeChanged = _data["canBeChanged"];
            this.order = _data["order"];
            this.sortableName = _data["sortableName"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["isDefault"] = this.isDefault;
        data["visible"] = this.visible;
        data["localizationKey"] = this.localizationKey;
        data["localizationSource"] = this.localizationSource;
        data["localizedField"] = this.localizedField;
        data["width"] = this.width;
        data["canBeChanged"] = this.canBeChanged;
        data["order"] = this.order;
        data["sortableName"] = this.sortableName;
        return data;
    }
}

export interface IMazarsColumnDefinitionDto {
    field: string | undefined;
    isDefault: boolean;
    visible: boolean;
    localizationKey: string | undefined;
    localizationSource: string | undefined;
    localizedField: string | undefined;
    width: number;
    canBeChanged: boolean;
    order: number;
    sortableName: string | undefined;
}

export class MazarsColumnDefinitionInput implements IMazarsColumnDefinitionInput {
    field!: string | undefined;
    isDefault!: boolean;
    visible!: boolean;
    localizationKey!: string | undefined;
    localizationSource!: string | undefined;
    width!: number;
    canBeChanged!: boolean;

    constructor(data?: IMazarsColumnDefinitionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.isDefault = _data["isDefault"];
            this.visible = _data["visible"];
            this.localizationKey = _data["localizationKey"];
            this.localizationSource = _data["localizationSource"];
            this.width = _data["width"];
            this.canBeChanged = _data["canBeChanged"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionInput {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["isDefault"] = this.isDefault;
        data["visible"] = this.visible;
        data["localizationKey"] = this.localizationKey;
        data["localizationSource"] = this.localizationSource;
        data["width"] = this.width;
        data["canBeChanged"] = this.canBeChanged;
        return data;
    }
}

export interface IMazarsColumnDefinitionInput {
    field: string | undefined;
    isDefault: boolean;
    visible: boolean;
    localizationKey: string | undefined;
    localizationSource: string | undefined;
    width: number;
    canBeChanged: boolean;
}

export class MazarsColumnDefinitionSettings implements IMazarsColumnDefinitionSettings {
    haveGeneralInfo!: boolean;
    haveName!: boolean;
    isTaggable!: boolean;
    haveFullProjectManagementInfo!: boolean;
    haveAssignedUser!: boolean;
    havePlanDates!: boolean;
    haveProjectInfo!: boolean;
    haveCreatedInfo!: boolean;
    haveUpdateInfo!: boolean;
    haveMultiselect!: boolean;

    constructor(data?: IMazarsColumnDefinitionSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haveGeneralInfo = _data["haveGeneralInfo"];
            this.haveName = _data["haveName"];
            this.isTaggable = _data["isTaggable"];
            this.haveFullProjectManagementInfo = _data["haveFullProjectManagementInfo"];
            this.haveAssignedUser = _data["haveAssignedUser"];
            this.havePlanDates = _data["havePlanDates"];
            this.haveProjectInfo = _data["haveProjectInfo"];
            this.haveCreatedInfo = _data["haveCreatedInfo"];
            this.haveUpdateInfo = _data["haveUpdateInfo"];
            this.haveMultiselect = _data["haveMultiselect"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haveGeneralInfo"] = this.haveGeneralInfo;
        data["haveName"] = this.haveName;
        data["isTaggable"] = this.isTaggable;
        data["haveFullProjectManagementInfo"] = this.haveFullProjectManagementInfo;
        data["haveAssignedUser"] = this.haveAssignedUser;
        data["havePlanDates"] = this.havePlanDates;
        data["haveProjectInfo"] = this.haveProjectInfo;
        data["haveCreatedInfo"] = this.haveCreatedInfo;
        data["haveUpdateInfo"] = this.haveUpdateInfo;
        data["haveMultiselect"] = this.haveMultiselect;
        return data;
    }
}

export interface IMazarsColumnDefinitionSettings {
    haveGeneralInfo: boolean;
    haveName: boolean;
    isTaggable: boolean;
    haveFullProjectManagementInfo: boolean;
    haveAssignedUser: boolean;
    havePlanDates: boolean;
    haveProjectInfo: boolean;
    haveCreatedInfo: boolean;
    haveUpdateInfo: boolean;
    haveMultiselect: boolean;
}

export class MazarsGridDefinitionDto implements IMazarsGridDefinitionDto {
    tableId!: string | undefined;
    settings!: MazarsColumnDefinitionSettings | undefined;
    configuration!: MazarsColumnDefinitionDto[] | undefined;

    constructor(data?: IMazarsGridDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableId = _data["tableId"];
            this.settings = _data["settings"] ? MazarsColumnDefinitionSettings.fromJS(_data["settings"]) : <any>undefined;
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(MazarsColumnDefinitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MazarsGridDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsGridDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableId"] = this.tableId;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMazarsGridDefinitionDto {
    tableId: string | undefined;
    settings: MazarsColumnDefinitionSettings | undefined;
    configuration: MazarsColumnDefinitionDto[] | undefined;
}

export class MazarsGridDefinitionInput implements IMazarsGridDefinitionInput {
    tableId!: string | undefined;
    configuration!: MazarsColumnDefinitionInput[] | undefined;

    constructor(data?: IMazarsGridDefinitionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableId = _data["tableId"];
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(MazarsColumnDefinitionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MazarsGridDefinitionInput {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsGridDefinitionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableId"] = this.tableId;
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMazarsGridDefinitionInput {
    tableId: string | undefined;
    configuration: MazarsColumnDefinitionInput[] | undefined;
}

export class MonthOnlyDto implements IMonthOnlyDto {
    month!: number;
    year!: number;

    constructor(data?: IMonthOnlyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): MonthOnlyDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthOnlyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface IMonthOnlyDto {
    month: number;
    year: number;
}

export class MonthlyReoccurrenceDto implements IMonthlyReoccurrenceDto {
    day!: number;
    startingFrom!: MonthOnlyDto | undefined;
    interval!: number;

    constructor(data?: IMonthlyReoccurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.startingFrom = _data["startingFrom"] ? MonthOnlyDto.fromJS(_data["startingFrom"]) : <any>undefined;
            this.interval = _data["interval"];
        }
    }

    static fromJS(data: any): MonthlyReoccurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyReoccurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["startingFrom"] = this.startingFrom ? this.startingFrom.toJSON() : <any>undefined;
        data["interval"] = this.interval;
        return data;
    }
}

export interface IMonthlyReoccurrenceDto {
    day: number;
    startingFrom: MonthOnlyDto | undefined;
    interval: number;
}

export class PagedResultDtoOfAccessTokenDto implements IPagedResultDtoOfAccessTokenDto {
    items!: AccessTokenDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfAccessTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AccessTokenDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfAccessTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAccessTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfAccessTokenDto {
    items: AccessTokenDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfJobDto implements IPagedResultDtoOfJobDto {
    items!: JobDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfJobDto {
    items: JobDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfRecordDto implements IPagedResultDtoOfRecordDto {
    items!: RecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfRecordDto {
    items: RecordDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfRecordGroupDto implements IPagedResultDtoOfRecordGroupDto {
    items!: RecordGroupDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfRecordGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RecordGroupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfRecordGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRecordGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfRecordGroupDto {
    items: RecordGroupDto[] | undefined;
    totalCount: number;
}

export class ProtocolFiltersDto implements IProtocolFiltersDto {
    searchString!: string | undefined;
    status!: ValidationStatusDto[] | undefined;
    type!: ValidationTypeDto[] | undefined;
    creationDate!: FilterInterval | undefined;
    creator!: number[] | undefined;
    source!: ValidationSourceDto[] | undefined;
    organizationUnitId!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: IProtocolFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            if (Array.isArray(_data["type"])) {
                this.type = [] as any;
                for (let item of _data["type"])
                    this.type!.push(item);
            }
            this.creationDate = _data["creationDate"] ? FilterInterval.fromJS(_data["creationDate"]) : <any>undefined;
            if (Array.isArray(_data["creator"])) {
                this.creator = [] as any;
                for (let item of _data["creator"])
                    this.creator!.push(item);
            }
            if (Array.isArray(_data["source"])) {
                this.source = [] as any;
                for (let item of _data["source"])
                    this.source!.push(item);
            }
            if (Array.isArray(_data["organizationUnitId"])) {
                this.organizationUnitId = [] as any;
                for (let item of _data["organizationUnitId"])
                    this.organizationUnitId!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProtocolFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProtocolFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchString"] = this.searchString;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item of this.type)
                data["type"].push(item);
        }
        data["creationDate"] = this.creationDate ? this.creationDate.toJSON() : <any>undefined;
        if (Array.isArray(this.creator)) {
            data["creator"] = [];
            for (let item of this.creator)
                data["creator"].push(item);
        }
        if (Array.isArray(this.source)) {
            data["source"] = [];
            for (let item of this.source)
                data["source"].push(item);
        }
        if (Array.isArray(this.organizationUnitId)) {
            data["organizationUnitId"] = [];
            for (let item of this.organizationUnitId)
                data["organizationUnitId"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProtocolFiltersDto {
    searchString: string | undefined;
    status: ValidationStatusDto[] | undefined;
    type: ValidationTypeDto[] | undefined;
    creationDate: FilterInterval | undefined;
    creator: number[] | undefined;
    source: ValidationSourceDto[] | undefined;
    organizationUnitId: UserOrOrganizationUnitInput[] | undefined;
}

export enum QualifiedResultType {
    Disclosure = 0,
    Matched = 1,
}

export enum QualifiedServiceDto {
    EVatR = 0,
    VIES = 1,
}

export class QualifiedValidationDataDto implements IQualifiedValidationDataDto {
    service!: QualifiedServiceDto;
    companyName!: string | undefined;
    companyStreet!: string | undefined;
    companyZip!: string | undefined;
    companyCounty!: string | undefined;

    constructor(data?: IQualifiedValidationDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
            this.companyName = _data["companyName"];
            this.companyStreet = _data["companyStreet"];
            this.companyZip = _data["companyZip"];
            this.companyCounty = _data["companyCounty"];
        }
    }

    static fromJS(data: any): QualifiedValidationDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedValidationDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["companyName"] = this.companyName;
        data["companyStreet"] = this.companyStreet;
        data["companyZip"] = this.companyZip;
        data["companyCounty"] = this.companyCounty;
        return data;
    }
}

export interface IQualifiedValidationDataDto {
    service: QualifiedServiceDto;
    companyName: string | undefined;
    companyStreet: string | undefined;
    companyZip: string | undefined;
    companyCounty: string | undefined;
}

export class QualifiedValidationResultDto implements IQualifiedValidationResultDto {
    service!: QualifiedServiceDto;
    discriminator!: QualifiedResultType;
    matchedResult!: MatchedValidationResultDto | undefined;
    disclosureResult!: DisclosureValidationResultDto | undefined;

    constructor(data?: IQualifiedValidationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
            this.discriminator = _data["discriminator"];
            this.matchedResult = _data["matchedResult"] ? MatchedValidationResultDto.fromJS(_data["matchedResult"]) : <any>undefined;
            this.disclosureResult = _data["disclosureResult"] ? DisclosureValidationResultDto.fromJS(_data["disclosureResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QualifiedValidationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedValidationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["discriminator"] = this.discriminator;
        data["matchedResult"] = this.matchedResult ? this.matchedResult.toJSON() : <any>undefined;
        data["disclosureResult"] = this.disclosureResult ? this.disclosureResult.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQualifiedValidationResultDto {
    service: QualifiedServiceDto;
    discriminator: QualifiedResultType;
    matchedResult: MatchedValidationResultDto | undefined;
    disclosureResult: DisclosureValidationResultDto | undefined;
}

export class RecordDto implements IRecordDto {
    id!: number;
    customGrants!: UserOrOrganizationUnitDto[] | undefined;
    creatorUser!: AssignableUserDto | undefined;
    creationTime!: DateTime;
    accessToken!: ReferenceDto | undefined;
    validation!: ReferenceDto | undefined;
    source!: ValidationSourceDto;
    result!: ValidationResultDto | undefined;

    constructor(data?: IRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["customGrants"])) {
                this.customGrants = [] as any;
                for (let item of _data["customGrants"])
                    this.customGrants!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            this.creatorUser = _data["creatorUser"] ? AssignableUserDto.fromJS(_data["creatorUser"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.accessToken = _data["accessToken"] ? ReferenceDto.fromJS(_data["accessToken"]) : <any>undefined;
            this.validation = _data["validation"] ? ReferenceDto.fromJS(_data["validation"]) : <any>undefined;
            this.source = _data["source"];
            this.result = _data["result"] ? ValidationResultDto.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.customGrants)) {
            data["customGrants"] = [];
            for (let item of this.customGrants)
                data["customGrants"].push(item.toJSON());
        }
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["accessToken"] = this.accessToken ? this.accessToken.toJSON() : <any>undefined;
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["source"] = this.source;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRecordDto {
    id: number;
    customGrants: UserOrOrganizationUnitDto[] | undefined;
    creatorUser: AssignableUserDto | undefined;
    creationTime: DateTime;
    accessToken: ReferenceDto | undefined;
    validation: ReferenceDto | undefined;
    source: ValidationSourceDto;
    result: ValidationResultDto | undefined;
}

export class RecordGroupDto implements IRecordGroupDto {
    id!: string | undefined;
    requestedVatId!: string | undefined;
    requesterVatId!: string | undefined;
    lastValidation!: RecordDto | undefined;

    constructor(data?: IRecordGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestedVatId = _data["requestedVatId"];
            this.requesterVatId = _data["requesterVatId"];
            this.lastValidation = _data["lastValidation"] ? RecordDto.fromJS(_data["lastValidation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RecordGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestedVatId"] = this.requestedVatId;
        data["requesterVatId"] = this.requesterVatId;
        data["lastValidation"] = this.lastValidation ? this.lastValidation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRecordGroupDto {
    id: string | undefined;
    requestedVatId: string | undefined;
    requesterVatId: string | undefined;
    lastValidation: RecordDto | undefined;
}

export class ReferenceDto implements IReferenceDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IReferenceDto {
    name: string | undefined;
    id: number;
}

export class ReoccurrenceDto implements IReoccurrenceDto {
    discriminator!: ReoccurrenceTypeDto;
    monthly!: MonthlyReoccurrenceDto | undefined;
    daily!: DailyReoccurrenceDto | undefined;

    constructor(data?: IReoccurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.monthly = _data["monthly"] ? MonthlyReoccurrenceDto.fromJS(_data["monthly"]) : <any>undefined;
            this.daily = _data["daily"] ? DailyReoccurrenceDto.fromJS(_data["daily"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReoccurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReoccurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["monthly"] = this.monthly ? this.monthly.toJSON() : <any>undefined;
        data["daily"] = this.daily ? this.daily.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReoccurrenceDto {
    discriminator: ReoccurrenceTypeDto;
    monthly: MonthlyReoccurrenceDto | undefined;
    daily: DailyReoccurrenceDto | undefined;
}

export enum ReoccurrenceTypeDto {
    Monthly = 0,
    Daily = 1,
}

export enum SimpleServiceDto {
    EVatR = 0,
    VIES = 1,
}

export class SimpleValidationDataDto implements ISimpleValidationDataDto {
    service!: SimpleServiceDto;

    constructor(data?: ISimpleValidationDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
        }
    }

    static fromJS(data: any): SimpleValidationDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleValidationDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        return data;
    }
}

export interface ISimpleValidationDataDto {
    service: SimpleServiceDto;
}

export class SimpleValidationResultDto implements ISimpleValidationResultDto {
    service!: SimpleServiceDto;

    constructor(data?: ISimpleValidationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
        }
    }

    static fromJS(data: any): SimpleValidationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleValidationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        return data;
    }
}

export interface ISimpleValidationResultDto {
    service: SimpleServiceDto;
}

export class UpdateAccessTokenInput implements IUpdateAccessTokenInput {
    name!: string | undefined;
    customGrants!: UserOrOrganizationUnitInput[] | undefined;
    expirationDate!: DateTime | undefined;
    note!: string | undefined;
    id!: number;

    constructor(data?: IUpdateAccessTokenInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["customGrants"])) {
                this.customGrants = [] as any;
                for (let item of _data["customGrants"])
                    this.customGrants!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateAccessTokenInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccessTokenInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customGrants)) {
            data["customGrants"] = [];
            for (let item of this.customGrants)
                data["customGrants"].push(item.toJSON());
        }
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : <any>undefined;
        data["note"] = this.note;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateAccessTokenInput {
    name: string | undefined;
    customGrants: UserOrOrganizationUnitInput[] | undefined;
    expirationDate: DateTime | undefined;
    note: string | undefined;
    id: number;
}

export class UpdateJobInput implements IUpdateJobInput {
    name!: string | undefined;
    reoccurrence!: ReoccurrenceDto | undefined;
    data!: ValidationDataInput | undefined;
    assignedUserId!: number | undefined;
    notifier!: JobNotifierDto;
    retry!: boolean;
    customGrants!: UserOrOrganizationUnitInput[] | undefined;
    id!: number;

    constructor(data?: IUpdateJobInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.reoccurrence = _data["reoccurrence"] ? ReoccurrenceDto.fromJS(_data["reoccurrence"]) : <any>undefined;
            this.data = _data["data"] ? ValidationDataInput.fromJS(_data["data"]) : <any>undefined;
            this.assignedUserId = _data["assignedUserId"];
            this.notifier = _data["notifier"];
            this.retry = _data["retry"];
            if (Array.isArray(_data["customGrants"])) {
                this.customGrants = [] as any;
                for (let item of _data["customGrants"])
                    this.customGrants!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateJobInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reoccurrence"] = this.reoccurrence ? this.reoccurrence.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["assignedUserId"] = this.assignedUserId;
        data["notifier"] = this.notifier;
        data["retry"] = this.retry;
        if (Array.isArray(this.customGrants)) {
            data["customGrants"] = [];
            for (let item of this.customGrants)
                data["customGrants"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateJobInput {
    name: string | undefined;
    reoccurrence: ReoccurrenceDto | undefined;
    data: ValidationDataInput | undefined;
    assignedUserId: number | undefined;
    notifier: JobNotifierDto;
    retry: boolean;
    customGrants: UserOrOrganizationUnitInput[] | undefined;
    id: number;
}

export class UserOrOrganizationUnitDto implements IUserOrOrganizationUnitDto {
    type!: string | undefined;
    userOrOrganizationId!: number;
    displayName!: string | undefined;

    constructor(data?: IUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userOrOrganizationId = _data["userOrOrganizationId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userOrOrganizationId"] = this.userOrOrganizationId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUserOrOrganizationUnitDto {
    type: string | undefined;
    userOrOrganizationId: number;
    displayName: string | undefined;
}

export class UserOrOrganizationUnitInput implements IUserOrOrganizationUnitInput {
    type!: string | undefined;
    userOrOrganizationId!: number;

    constructor(data?: IUserOrOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userOrOrganizationId = _data["userOrOrganizationId"];
        }
    }

    static fromJS(data: any): UserOrOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userOrOrganizationId"] = this.userOrOrganizationId;
        return data;
    }
}

export interface IUserOrOrganizationUnitInput {
    type: string | undefined;
    userOrOrganizationId: number;
}

export class ValidationDataDto implements IValidationDataDto {
    requesterVatId!: string | undefined;
    requestedVatId!: string | undefined;
    discriminator!: ValidationTypeDto;
    simpleData!: SimpleValidationDataDto | undefined;
    qualifiedData!: QualifiedValidationDataDto | undefined;

    constructor(data?: IValidationDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requesterVatId = _data["requesterVatId"];
            this.requestedVatId = _data["requestedVatId"];
            this.discriminator = _data["discriminator"];
            this.simpleData = _data["simpleData"] ? SimpleValidationDataDto.fromJS(_data["simpleData"]) : <any>undefined;
            this.qualifiedData = _data["qualifiedData"] ? QualifiedValidationDataDto.fromJS(_data["qualifiedData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidationDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requesterVatId"] = this.requesterVatId;
        data["requestedVatId"] = this.requestedVatId;
        data["discriminator"] = this.discriminator;
        data["simpleData"] = this.simpleData ? this.simpleData.toJSON() : <any>undefined;
        data["qualifiedData"] = this.qualifiedData ? this.qualifiedData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidationDataDto {
    requesterVatId: string | undefined;
    requestedVatId: string | undefined;
    discriminator: ValidationTypeDto;
    simpleData: SimpleValidationDataDto | undefined;
    qualifiedData: QualifiedValidationDataDto | undefined;
}

export class ValidationDataInput implements IValidationDataInput {
    requesterVatId!: string;
    requestedVatId!: string;
    discriminator!: ValidationTypeDto;
    simpleInput!: ValidationSimpleInput | undefined;
    qualifiedInput!: ValidationQualifiedInput | undefined;

    constructor(data?: IValidationDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requesterVatId = _data["requesterVatId"];
            this.requestedVatId = _data["requestedVatId"];
            this.discriminator = _data["discriminator"];
            this.simpleInput = _data["simpleInput"] ? ValidationSimpleInput.fromJS(_data["simpleInput"]) : <any>undefined;
            this.qualifiedInput = _data["qualifiedInput"] ? ValidationQualifiedInput.fromJS(_data["qualifiedInput"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidationDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requesterVatId"] = this.requesterVatId;
        data["requestedVatId"] = this.requestedVatId;
        data["discriminator"] = this.discriminator;
        data["simpleInput"] = this.simpleInput ? this.simpleInput.toJSON() : <any>undefined;
        data["qualifiedInput"] = this.qualifiedInput ? this.qualifiedInput.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidationDataInput {
    requesterVatId: string;
    requestedVatId: string;
    discriminator: ValidationTypeDto;
    simpleInput: ValidationSimpleInput | undefined;
    qualifiedInput: ValidationQualifiedInput | undefined;
}

export class ValidationInput implements IValidationInput {
    customGrants!: UserOrOrganizationUnitInput[] | undefined;
    data!: ValidationDataInput | undefined;

    constructor(data?: IValidationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customGrants"])) {
                this.customGrants = [] as any;
                for (let item of _data["customGrants"])
                    this.customGrants!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.data = _data["data"] ? ValidationDataInput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customGrants)) {
            data["customGrants"] = [];
            for (let item of this.customGrants)
                data["customGrants"].push(item.toJSON());
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidationInput {
    customGrants: UserOrOrganizationUnitInput[] | undefined;
    data: ValidationDataInput | undefined;
}

export class ValidationQualifiedInput implements IValidationQualifiedInput {
    service!: QualifiedServiceDto;
    companyName!: string | undefined;
    companyStreet!: string | undefined;
    companyZip!: string | undefined;
    companyCounty!: string | undefined;

    constructor(data?: IValidationQualifiedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
            this.companyName = _data["companyName"];
            this.companyStreet = _data["companyStreet"];
            this.companyZip = _data["companyZip"];
            this.companyCounty = _data["companyCounty"];
        }
    }

    static fromJS(data: any): ValidationQualifiedInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationQualifiedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["companyName"] = this.companyName;
        data["companyStreet"] = this.companyStreet;
        data["companyZip"] = this.companyZip;
        data["companyCounty"] = this.companyCounty;
        return data;
    }
}

export interface IValidationQualifiedInput {
    service: QualifiedServiceDto;
    companyName: string | undefined;
    companyStreet: string | undefined;
    companyZip: string | undefined;
    companyCounty: string | undefined;
}

export class ValidationResultDto implements IValidationResultDto {
    rawResponse!: string | undefined;
    requestReference!: string | undefined;
    error!: string | undefined;
    status!: ValidationStatusDto;
    requesterVatId!: string | undefined;
    requestedVatId!: string | undefined;
    validVatId!: boolean | undefined;
    discriminator!: ValidationTypeDto;
    simpleResult!: SimpleValidationResultDto | undefined;
    qualifiedResult!: QualifiedValidationResultDto | undefined;

    constructor(data?: IValidationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rawResponse = _data["rawResponse"];
            this.requestReference = _data["requestReference"];
            this.error = _data["error"];
            this.status = _data["status"];
            this.requesterVatId = _data["requesterVatId"];
            this.requestedVatId = _data["requestedVatId"];
            this.validVatId = _data["validVatId"];
            this.discriminator = _data["discriminator"];
            this.simpleResult = _data["simpleResult"] ? SimpleValidationResultDto.fromJS(_data["simpleResult"]) : <any>undefined;
            this.qualifiedResult = _data["qualifiedResult"] ? QualifiedValidationResultDto.fromJS(_data["qualifiedResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawResponse"] = this.rawResponse;
        data["requestReference"] = this.requestReference;
        data["error"] = this.error;
        data["status"] = this.status;
        data["requesterVatId"] = this.requesterVatId;
        data["requestedVatId"] = this.requestedVatId;
        data["validVatId"] = this.validVatId;
        data["discriminator"] = this.discriminator;
        data["simpleResult"] = this.simpleResult ? this.simpleResult.toJSON() : <any>undefined;
        data["qualifiedResult"] = this.qualifiedResult ? this.qualifiedResult.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidationResultDto {
    rawResponse: string | undefined;
    requestReference: string | undefined;
    error: string | undefined;
    status: ValidationStatusDto;
    requesterVatId: string | undefined;
    requestedVatId: string | undefined;
    validVatId: boolean | undefined;
    discriminator: ValidationTypeDto;
    simpleResult: SimpleValidationResultDto | undefined;
    qualifiedResult: QualifiedValidationResultDto | undefined;
}

export class ValidationSimpleInput implements IValidationSimpleInput {
    service!: SimpleServiceDto;

    constructor(data?: IValidationSimpleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
        }
    }

    static fromJS(data: any): ValidationSimpleInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationSimpleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        return data;
    }
}

export interface IValidationSimpleInput {
    service: SimpleServiceDto;
}

export enum ValidationSourceDto {
    Once = 0,
    Job = 1,
    AccessToken = 2,
}

export enum ValidationStatusDto {
    Valid = 0,
    Invalid = 1,
    Failure = 2,
    Unknown = 3,
}

export enum ValidationTypeDto {
    Simple = 0,
    Qualified = 1,
}

export class ValueTupleOfIEnumerableOfInt64Boolean implements IValueTupleOfIEnumerableOfInt64Boolean {

    constructor(data?: IValueTupleOfIEnumerableOfInt64Boolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueTupleOfIEnumerableOfInt64Boolean {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfIEnumerableOfInt64Boolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IValueTupleOfIEnumerableOfInt64Boolean {
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

// copied from HttpClient.request, for some reason its not a type there ¯\_(ツ)_/¯ 
export interface RequestOptions {
    body?: any;
    headers?: http.HttpHeaders | {
        [header: string]: string | string[];
    };
    context?: http.HttpContext;
    observe?: 'body';
    params?: http.HttpParams | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
    reportProgress?: boolean;
    responseType: 'arraybuffer';
    withCredentials?: boolean;
    transferCache?: {
        includeHeaders?: string[];
    } | boolean;
}

export class ServiceProxyBase {
    async transformOptions(options: RequestOptions): Promise<RequestOptions> {
        return options
    }
}